import { PureComponent } from 'react';

import MenuqItem from 'Component/MenuqItem';
import { getSortedItems } from 'Util/Menu';

import './Menuq.style';

export class Menuq extends PureComponent {
    stopPropagation(e) {
        e.stopPropagation();
    }

    renderSubLevelItems(item, isSecondLevel) {
        const {
            handleSubcategoryClick,
            activeMenuItemsStack
        } = this.props;

        const { item_id, children, title, item_class } = item;

        if (title === 'Banner') {
            return null;
        }

        const childrenArray = getSortedItems(Object.values(children));
        const subcategoryMods = { type: 'subcategory', isSecondLevel };

        if (childrenArray.length) {
            return (
                <div
                  block="Menuq"
                  elem="ItemInnerLink"
                  key={ item_id }
                  // TODO: split into smaller components
                  // eslint-disable-next-line react/jsx-no-bind
                  onClick={ (e) => handleSubcategoryClick(e, item) }
                  tabIndex="0"
                  role="button"
                >
                    <MenuqItem
                      activeMenuItemsStack={ activeMenuItemsStack }
                      item={ item }
                      itemMods={ { ...subcategoryMods, isExpanded: activeMenuItemsStack.includes(item_id) } }
                      isExpandable
                    />
                    { this.renderSubLevel(item) }
                </div>
            );
        }

        return (
            <div
              block="Menuq"
              elem="ItemInnerLink"
              key={ item_id }
              onClick={ this.stopPropagation }
              role="button"
              tabIndex="-1"
              className={ item_class }
            >
                <MenuqItem
                  activeMenuItemsStack={ activeMenuItemsStack }
                  item={ item }
                  itemMods={ subcategoryMods }
                  isLink
                />
            </div>
        );
    }

    renderSubLevel(category, isSecondLevel = false) {
        const { activeMenuItemsStack } = this.props;
        const { item_id, children, item_class } = category;
        const childrenArray = getSortedItems(Object.values(children));
        const isVisible = activeMenuItemsStack.includes(item_id);
        const subcategoryMods = { type: 'subcategory' };

        return (
            <div
              block="Menuq"
              elem="SubMenu"
              mods={ { isVisible } }
              key={ item_id }
            >
                <div
                  block="Menuq"
                  elem="ItemList"
                  mods={ { ...subcategoryMods } }
                >
                    { childrenArray.map((item) => this.renderSubLevelItems(item, isSecondLevel)) }
                </div>
            </div>
        );
    }

    renderSubMenuDesktopItems(item) {
        const { item_id, children } = item;

        if (!Object.keys(children).length) {
            return null;
        }

        const { activeMenuItemsStack, closeMenu } = this.props;
        const isVisible = activeMenuItemsStack.includes(item_id);

        if (!isVisible) {
            return null;
        }

        return (
            <div
              block="Menuq"
              elem="SubCategoriesWrapper"
              mods={ { isVisible } }
              key={ item_id }
            >
                <div
                  block="Menuq"
                  elem="SubCategoriesWrapperInner"
                  mods={ { isVisible } }
                >
                    <div
                      block="Menuq"
                      elem="SubCategories"
                    >
                        { this.renderSubLevel(item) }
                    </div>
                </div>
            </div>
        );
    }

    renderSubMenuDesktop(itemList) {
        const childrenArray = getSortedItems(Object.values(itemList));

        return childrenArray.map(this.renderSubMenuDesktopItems.bind(this));
    }

    renderFirstLevelItems(item) {
        const {
            activeMenuItemsStack,
            handleTopLevelClick
        } = this.props;

        const { children, item_id } = item;
        const childrenArray = Object.values(children);
        const itemMods = { type: 'main' };
        const isExpanded = activeMenuItemsStack.includes(item_id);

        if (childrenArray.length) {
            return (
                <div
                  // TODO: split into smaller components
                  // eslint-disable-next-line react/jsx-no-bind
                  onClick={ (e) => handleTopLevelClick(e, item, childrenArray) }
                  tabIndex="0"
                  block="Menuq"
                  elem="ItemLink"
                  mods={{ isExpanded }}
                  role="button"
                >
                    <MenuqItem
                      activeMenuItemsStack={ activeMenuItemsStack }
                      item={ item }
                      itemMods={ { ...itemMods, isExpanded } }
                      isExpandable
                    />
                </div>
            );
        }

        return (
            <MenuqItem
              activeMenuItemsStack={ activeMenuItemsStack }
              item={ item }
              itemMods={ itemMods }
              isLink
            />
        );
    }

    renderFirstLevel(item) {
        const { item_id, item_class } = item;

        return (
            <li
              block="Menuq"
              elem="Item"
              key={ item_id }
              // eslint-disable-next-line react/forbid-dom-props
              className={ item_class }
            >
                { this.renderFirstLevelItems.call(this, item) }
            </li>
        );
    }

    renderTopLevel() {
        const { menu } = this.props;
        const categoryArray = Object.values(menu);

        if (!categoryArray.length) {
            return null;
        }

        const childrenProducts = categoryArray[0].children; // get "Products" children
        const childrenProductsArray = getSortedItems(Object.values(childrenProducts));
        categoryArray.shift(); // remove "Products" element

        const newMenu = {
            ...childrenProducts,
            ...menu
        }

        const newCategoryArray = [
            ...childrenProductsArray,
            ...categoryArray
        ]

        return (
            <>
                <ul block="Menuq" elem="MainCategories">
                    { newCategoryArray.map(this.renderFirstLevel.bind(this)) }
                </ul>
                { this.renderSubMenuDesktop(newMenu) }
            </>
        );
    }

    render() {
        return (
            <div
              block="Menuq"
              elem="MenuWrapper"
            >
                { this.renderTopLevel() }
            </div>
        );
    }
}

export default Menuq;
